import { QUERY_KEYS } from "@/libraries/constant";
import { getCaseLetter } from "@/queries";
import { DataIdSchema } from "@/schemas";
import type { GetCaseLetterResponse } from "@/types";
import { onlineManager } from "@tanstack/react-query";
import { Outlet, createFileRoute, notFound } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/dashboard/case/view/$id/letter/$letterId",
)({
	params: {
		parse: (params) => ({
			letterId: DataIdSchema.parse(Number(params.letterId)),
		}),
		stringify: ({ letterId }) => ({ letterId: letterId.toString() }),
	},
	loader: async ({ context, params }) => {
		const resCaseLetter =
			onlineManager.isOnline() && !context.isRestoring
				? await context.queryClient.ensureQueryData(
						getCaseLetter(params.letterId),
					)
				: context.queryClient.getQueryData<GetCaseLetterResponse>([
						QUERY_KEYS.GET_CASE_LETTER,
						params.letterId,
					]);
		if (!resCaseLetter) throw notFound();
		return resCaseLetter.case_letter;
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
